import { useEffect } from "react";
import InnerDetails from "../../../../../components/reports/Inner-details.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({ data, searchDetails, tableColumns }) => {
    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "SLA do servidor", "sla-server-data",);
    }, [data, tableColumns]);

    if (!data) return null;

    const columns = [
        { id: "sla", colSpan: 2, value: data.server_on_percentage },
        { id: "inactive", colSpan: 2, value: data.server_off_percentage },
        { id: "inactiveTime", value: data.server_off_time },
        { id: "events", value: data.events?.length ?? 0 },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="sla-server-data" className="table report-table" sheet-name="SLA do servidor">
                    <thead className="thead-background print:table-row-group!">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id} colSpan={column.colSpan}>
                                    {tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        <tr className={`table-break-word ${searchDetails ? "details-row" : ""}`}>
                            {visibleColumns.map((column) => (
                                <td key={column.id} colSpan={column.colSpan}>
                                    {column.value}
                                </td>
                            ))}
                        </tr>

                        <InnerDetails searchDetails={searchDetails} events={data.events ?? []} colSpan={visibleColumns.reduce((total, column) => total + (column.colSpan ?? 1), 0,)}/>
                    </tbody>
                </table>
            ) : (
            <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;